// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"ebffe4dc","453":"a830548a","821":"bcd2652f","831":"ccd6e2cd","963":"e445a4d3"}[chunkId] + ".chunk.js";
};